import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { toast } from "react-toastify";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
} from "revalidate";
import { observer } from "mobx-react-lite";
import { IUsers, IUserCompany } from "../../../../app/models/user";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import TextInput from "../../../../app/common/form/TextInput";

const validate = combineValidators({
  username: composeValidators(
    matchesPattern(/^[a-zA-Z0-9\.\-_@]*$/)({
      message:
        "Usuario de acceso  no válido. Contiene espacios o caracteres especiales diferente a: - . _ @",
    }),
    isRequired({ message: "El Usuario es obligatorio" }),
    hasLengthGreaterThan(5)({
      message: "El Usuario de acceso debe tener al menos 6 caracteres",
    }),
    hasLengthLessThan(129)({
      message: "El Usuario de acceso debe tener máximo 128 caracteres",
    })
  )(),
  name: composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanuméricos",
    }),
    hasLengthLessThan(65)({
      message: "El Nombre debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Nombre debe tener al menos 2 caracteres",
    }),
  )(),
  lastName: composeValidators(
    isRequired({ message: "El Apellido es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(65)({
      message: "El Apellido debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Apellido debe tener al menos 2 caracteres",
    }),
  )(),
  phone: composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  email: composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

interface IProps {
  user: IUsers;
  brokerId: string;
}

const EditUserBrokerForm: React.FC<IProps> = ({ user, brokerId }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { editUserBroker } = rootStore.brokerStore;
  const { loading } = rootStore.buttonLoadingStore;
  const [editUserBrokerForm] = useState<IUserCompany>({
    id: user.id,
    name: user.name,
    lastName: user.lastName,
    phone: user.phone,
    email: user.email,
    username: user.username,
  });
  const handleFinalFormSubmit = (values: any) => {
    if (
      values.email !== editUserBrokerForm.email ||
      values.name !== editUserBrokerForm.name ||
      values.lastName !== editUserBrokerForm.lastName ||
      values.phone !== editUserBrokerForm.phone
    ) {
      values.name = values.name.trim();
      values.lastName = values.lastName.trim();
      values.email = values.email.trim();
      values.phone = values.phone.trim();
      editUserBroker(user.id, values, brokerId);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={editUserBrokerForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Usuario de acceso</label>
              <Field
                name="username"
                disabled={true}
                value={editUserBrokerForm.username}
                component={TextInput}
              />
              <label>Nombres</label>
              <Field
                name="name"
                value={editUserBrokerForm.name}
                component={TextInput}
              />
              <label>Apellidos</label>
              <Field
                name="lastName"
                value={editUserBrokerForm.lastName}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="phone"
                value={editUserBrokerForm.phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="email"
                value={editUserBrokerForm.email}
                component={TextInput}
              />
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditUserBrokerForm);
